<template>
  <v-dialog v-model="showEntityForm" persistent max-width="500">
    <v-card>
      <v-card-title>
        <h5 class="pt-5 pb-7">Entidade</h5>
      </v-card-title>
        <v-card-text class="align-center justify-center">
            <v-form ref="entityForm" v-model="isFormValid">
                <v-row>
                    <v-col cols="12">
                        <v-select
                            v-model="selectedEntityType"
                            :items="entityTypeList"
                            required
                            label="Entidade"
                            item-text="name"
                            outlined
                            return-object
                            hide-details="auto"                                                        
                            :rules="[validateEntityTypeOption]"     
                            @change="validateEntity"                                                
                        ></v-select>
                    </v-col>
                    <v-col cols="12">
                        <v-select
                            v-model="selectedSecretary"
                            :items="secretariesList"
                            item-text="entityViewModel.name"
                            label="Secretaria"
                            outlined
                            hide-details="auto"
                            return-object
                            :rules="[validateSecretariesList]"
                            v-if="isSecretarySelected"
                        ></v-select>
                         <v-select
                            v-model="selectedInstitution"
                            :items="institutionsList"
                            item-text="entityViewModel.name"
                            label="Instituição"
                            outlined                                                        
                            hide-details="auto"
                            return-object
                            :rules="[validateInstitutionList]"
                            v-if="isInstitutionSelected"
                        ></v-select>
                         <v-select
                            :items="councilList"
                            item-text="entityViewModel.name"
                            label="Conselho"
                            outlined
                            return-object
                            hide-details="auto"
                            v-model="selectedCouncil"
                            :rules="[validateCouncilList]"
                            v-if="isCouncilSelected"
                        ></v-select>
                    </v-col>
                    <v-col cols="12">
                        <v-select
                            v-model="selectedJobRole"
                            :items="jobRolesList"
                            item-text="name"
                            label="Cargo"
                            return-object
                            outlined
                            hide-details="auto"                                                        
                            :rules="[validateJobRoleOption]"
                            v-if="isSecretarySelected || isInstitutionSelected ||isCouncilSelected"
                        ></v-select>
                    </v-col>
                </v-row>
            </v-form>
        </v-card-text>
        <v-col cols="12" md="4">
            <v-checkbox v-if="isCouncilSelected" v-model="financial" dense label="Perfil Financeiro" color="var(--secondary)"></v-checkbox>
            <v-checkbox v-if="!isUserSelected" v-model="administrator" label="Administrador" color="var(--secondary)"></v-checkbox>
        </v-col>
         <v-card-actions class="px-6 py-5 d-flex space-between">
        <v-btn rounded large depressed outlined class="gray px-12" @click="hide()">Voltar</v-btn>
        <v-spacer></v-spacer>
            <v-btn
              color="info"
              rounded
              large
              depressed
              class="px-12"
              :disabled="!isFormValid"
            >Salvar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import GeneralService from "@/scripts/services/general.service";
import EntityService from "@/scripts/services/entity.service";
import EntityTypes from "@/scripts/enums/entityTypes.enum";
import JobRoles from "@/scripts/enums/jobRoles.enum";
export default {
  props: ["value"],
  data: () => ({
    entityService: new EntityService(),
    generalService: new GeneralService(),
    showEntityForm: false,
    isFormValid: false,
    entityTypeList: [],
    selectedEntityType: null,
    jobRolesList: [],
    selectedJobRole: null,
    secretariesList: [],
    selectedSecretary: null,
    institutionsList: [],
    selectedInstitution: null,
    financial: false,
    administrator: false,
  }),
  created(){
       this.entityService
            .listAllEntityTypes()
            .then((result) => (this.entityTypeList = result));

        this.entityService
            .listAllJobRoles()
            .then((result) => (this.jobRolesList = result));
  },
  computed: {
      isCouncilSelected(){
            return (
                this.selectedEntityType &&
                this.selectedEntityType.id == EntityTypes.Council
            );
        },
        isInstitutionSelected(){
            return (
                this.selectedEntityType &&
                this.selectedEntityType.id == EntityTypes.Institution
            );
        },
        isSecretarySelected(){
            return (
                this.selectedEntityType &&
                this.selectedEntityType.id == EntityTypes.Secretary
            );
        },
        isUserSelected(){
            return (
                this.selectedEntityType &&
                this.selectedEntityType.id == EntityTypes.User
            );
        },
        isPresidentSelected(){
            return (
                this.selectedJobRole &&
                this.selectedJobRole.id == JobRoles.President
            );
        },
        isRepresentativetSelected(){
            return (
                this.selectedJobRole &&
                this.selectedJobRole.id == JobRoles.Representative
            );
        },
        isOthersSelected(){
            return (
                this.selectedJobRole &&
                this.selectedJobRole.id == JobRoles.Others
            );
        }
  },
  watch: {
      value() {
      this.showEntityForm = this.value;
      if (this.showEntityForm) {
        this.clearForm();
      }
    },
    showEntityForm() {
      this.$emit("input", this.showEntityForm);
    }
  },
  methods: {
    getFilters() {
        return {                
            orderBy: this.selectedOrderBy,
            currentPage: this.currentPage - 1,
            pageSize: this.selectedPagination,
            searchTerms: this.searchTerms
        };
    },
    hide() {
      this.showEntityForm = false;
      this.$emit("input", this.value);
    },
    clearForm() {
      this.isFormValid = false;
    },
    validateSecretariesList(){
        if(this.selectedEntityType.id == EntityTypes.Secretary && !this.secretariesList) 
            return "selecione uma secretaria";
        return true;
    },
    validateInstitutionList(){
        if(this.selectedEntityType.id == EntityTypes.Institution && !this.institutionsList) 
            return "selecione uma instituição";
        return true;
    },
    validateCouncilList(){
        if(this.selectedEntityType.id == EntityTypes.Council && !this.councilList) 
            return "selecione um conselho";
        return true;
    },
    validateEntityTypeOption(){
        if(this.selectedEntityType != null && this.selectedEntityType.id > 0)
            return true;
        return "Escolha uma opção de tipo de entidade";
    },
    validateEntity(){
        if(this.selectedEntityType.id == EntityTypes.Secretary){                
            this.entityService
                .listSecretaries(this.getFilters())
                .then(result => (this.secretariesList = result));
        } else if (this.selectedEntityType.id == EntityTypes.Institution){
            this.entityService
                .listInstitutions(this.getFilters())
                .then(result => (this.institutionsList = result));
        } else if(this.selectedEntityType.id == EntityTypes.Council){
             this.entityService
                .listCouncils(this.getFilters())
                .then(result => (this.councilList = result));
        }
    },
    validateJobRoleOption(){
        if(!this.selectedJobRole != null) 
            return true;
        return "Escolha uma opção de cargo";
    },
  }  
};
</script>